import { render, staticRenderFns } from "./EditPersetujuan.vue?vue&type=template&id=dd025c6e&scoped=true&"
import script from "./EditPersetujuan.vue?vue&type=script&lang=js&"
export * from "./EditPersetujuan.vue?vue&type=script&lang=js&"
import style0 from "./EditPersetujuan.vue?vue&type=style&index=0&id=dd025c6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd025c6e",
  null
  
)

export default component.exports